import React from "react";
import { Circle } from "rc-progress";
import CountUp from "react-countup";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel } from "@fortawesome/free-solid-svg-icons";

const ClientsCard = ({ clients }) => {
  const getPendingClients = () => {
    return clients.filter(
      (client) => client.serviceAgreement?.agreed === false
    );
  };

  const totalClients = clients.length;
  const activeClients = totalClients - getPendingClients().length;
  const activePercentage =
    totalClients > 0 ? Math.round((activeClients / totalClients) * 100) : 0;
  const roundProgressColor =
    activePercentage <= 50
      ? "#FFA015"
      : activePercentage >= 50
      ? "#06BF9C"
      : "#3498DB";
  return (
    <>
      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <FontAwesomeIcon
            icon={faHotel}
            className="text-success fs-2 p-0 ps-2"
          />
        </Col>
        <Col xs="auto" className="round-progress">
          <Circle
            percent={activePercentage}
            strokeWidth={10}
            trailWidth={8}
            strokeColor={roundProgressColor}
          />
          <span
            className={activePercentage < 50 ? "text-warning" : "text-success"}
          >
            <CountUp start={0} end={activePercentage} delay={2} />%
          </span>
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <Row className="mt-3">
            <h5 className="fw-bold text-primary m-0">Total Clients</h5>
          </Row>
          <Row className="">
            <h4 className="fw-bolder text-info m-0">
              <CountUp start={0} end={totalClients} delay={2} />
            </h4>
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-between my-1">
        <Col xs="auto" className="text-muted">
          Active
        </Col>
        <Col xs="auto" className="text-success">
          <CountUp start={0} end={activeClients} delay={2} />
        </Col>
      </Row>
      <Row className="justify-content-between my-1">
        <Col xs="auto" className="text-muted">
          Pending
        </Col>
        <Col xs="auto" className="text-warning">
          <CountUp start={0} end={getPendingClients().length} delay={2} />
        </Col>
      </Row>
    </>
  );
};

export default ClientsCard;
